import styled from '@emotion/styled/macro';
import { NewStyledButton } from 'components/prime/NewButton/styled';

export const GoogleButton = styled(NewStyledButton)`
  width: 100%;
`;
